import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { Observable } from 'rxjs';
import { ContentRepositoryService } from '@app/core/services/content/content-repository.service';
import { PlatformService } from '@app/shared/services/platform/platform.service';
import { share } from 'rxjs/operators';
import { LocaleService } from '../i18n';

@Component({
  selector: 'vc-footer',
  templateUrl: 'footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  public footerData$: Observable<any>;
  public lang: string;
  public showDisclaimer: boolean;

  @Input()
  isHome: boolean;

  @Input()
  showAccessibilityLink: boolean;

  @Input()
  pageType: string;

  @Input()
  i18nvalue: string;

  constructor(
    private plateformService: PlatformService,
    private contentRepository: ContentRepositoryService,
    private localeService: LocaleService
  ) {}

  ngOnInit() {
    this.footerData$ = this.contentRepository.getFooter().pipe(share());
    this.lang = this.localeService.getLocale().toString();
    this.showDisclaimer = this.plateformService.isBrowser;
  }
}
